'use strict';

import {gaamendmentChecklistModel} from "../../models/gaamendmentchecklistmodel.js";
import {projectChangeModel} from "../../models/projectchangemodel.js";

export class GAchecklistsCtrl
{
	changeData = {};
//
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.changeData = new projectChangeModel(jsDataService.get('changeData', {}), $filter, jsDataService);

		if (this.changeData.lawyer && this.changeData.lawyer.time > 0) {
			this.changeData.lawyer.time = new Date(this.changeData.lawyer.time * 1000);
		}
		if (this.changeData.manager && this.changeData.manager.time > 0) {
			this.changeData.manager.time = new Date(this.changeData.manager.time * 1000);
		}

		this.postConstruct();
	}

	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new gaamendmentChecklistModel(evaluation, this.$filter, this.jsDataService);
	}

	getQuestions(){
		return this.evaluation.data_value.questions;
	}

	autosavePostFields(){
//		let post = this.evaluation.data_value.questions;
		return {
			questions: this.evaluation.data_value.questions,
			number: this.evaluation.data_value.GAnumber
		};
	}

	confirmEvaluation(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				this.notify(this.$filter('tr')('err_check_required_fields'), true);
			}
			else{
				const confirmTexts = this.jsDataService.get('gaChecklistSubmitTexts');
				const confirm = this.$mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.cancel(confirmTexts.cancel);
				this.$mdDialog.show(confirm).then(() => {
					this.$scope.basicHttpConfigProcess({
						url: this.jsDataService.get('cfgSubmitUrl'),
						method: 'GET',
						params: {}
					}).then((results) => {
						if(results.data.success){

						}
					});
				}, () => {});
			}
		});

	}

	lawyerEvaluation(ev) {
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
			templateUrl: 'projects/gachecklist_submit.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgLawyerActionUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}

	managerEvaluation(ev) {
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
			templateUrl: 'projects/gachecklist_submit.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgManagerActionUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}

	completeDialogCtrl($scope, $mdDialog) {
		$scope.comment = '';
		$scope.action;
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.approve = function () {
			$scope.action = 'approve';
			$scope.submitDialog();
		};

		$scope.disapprove = function () {
			$scope.action = 'disapprove';
			$scope.submitDialog();
		};

		$scope.return = function () {
			$scope.action = 'return';
			$scope.submitDialog();
		};

		$scope.submitDialog = function () {
			if (typeof ($scope.action) !== 'undefined' && $scope.action !== '') {
				$mdDialog.hide({
					action: $scope.action,
					comment: $scope.comment
				});
			} else {
				console.log('Undefined action');
			}
		};
	}

//	cancelEvaluation(ev){
//		this.$mdDialog.show({
//			controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
//			templateUrl: 'contracts/evaluation_return.html',
//			parent: angular.element(document.body),
//			targetEvent: ev,
//			clickOutsideToClose: false,
//			fullscreen: true
////				locals: {
////					evaluation: this.evaluation
////				}
//		}).then((results) => {
//			const url = this.jsDataService.get('cfgCancelUrl');
//			if (url) {
//				this.$scope.basicHttpConfigProcess({
//					url: url,
//					method: 'POST',
//					data: results
//				});
//			}
//		}, () => {
//		});
//
//	}
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}